import styled, { css } from 'styled-components'

interface PropsType {
  sideMargin?: string
  topMargin?: string
}

const Spacer = styled.div<PropsType>`
  ${({ sideMargin }) =>
    sideMargin &&
    css`
      margin: 0 ${sideMargin};
    `}
  ${({ topMargin }) =>
    topMargin &&
    css`
      margin: ${topMargin} 0;
    `}
`

export default Spacer
